import { BaseApiClient } from './base-client';
import type { ApiResponse } from '../../types';
import type { CommunicationStyle, Provider } from '../../stores/useCommunicationStyleStore';

/**
 * Communication Styles API - методы для работы со стилями общения
 */
export class CommunicationStylesApi extends BaseApiClient {
  
  /**
   * Получить все активные стили общения
   * @param provider - фильтр по провайдеру (опционально)
   */
  async getCommunicationStyles(provider?: Provider | string): Promise<ApiResponse<{ styles: CommunicationStyle[] }>> {
    const params = provider ? { provider } : {};
    const response = await this.client.get('/api/chat/styles', { params });
    return response.data;
  }

  /**
   * Получить все стили (включая неактивные) - только для админов
   */
  async getAllCommunicationStyles(): Promise<ApiResponse<{ styles: CommunicationStyle[] }>> {
    const response = await this.client.get('/api/chat/styles/all');
    return response.data;
  }

  /**
   * Получить текущий выбранный стиль пользователя
   */
  async getCurrentStyle(): Promise<ApiResponse<{ style: CommunicationStyle | null }>> {
    const response = await this.client.get('/api/chat/styles/current');
    return response.data;
  }

  /**
   * Выбрать стиль общения
   */
  async selectStyle(styleId: number | null): Promise<ApiResponse<{ style: CommunicationStyle | null }>> {
    const response = await this.client.post('/api/chat/styles/select', { styleId });
    return response.data;
  }

  /**
   * Создать новый стиль (только для админов)
   */
  async createStyle(styleData: {
    name: string;
    description: string;
    system_prompt: string;
    is_active?: boolean;
    display_order?: number;
    image_url?: string | null;
    supported_providers?: Provider[];
  }): Promise<ApiResponse<{ style: CommunicationStyle }>> {
    const response = await this.client.post('/api/chat/styles', styleData);
    return response.data;
  }

  /**
   * Обновить стиль (только для админов)
   */
  async updateStyle(styleId: number, updates: {
    name?: string;
    description?: string;
    system_prompt?: string;
    is_active?: boolean;
    display_order?: number;
    image_url?: string | null;
    supported_providers?: Provider[];
  }): Promise<ApiResponse<{ style: CommunicationStyle }>> {
    const response = await this.client.put(`/api/chat/styles/${styleId}`, updates);
    return response.data;
  }

  /**
   * Удалить стиль (только для админов)
   */
  async deleteStyle(styleId: number): Promise<ApiResponse<{ message: string }>> {
    const response = await this.client.delete(`/api/chat/styles/${styleId}`);
    return response.data;
  }
}

